module.exports = __webpack_public_path__ + "static/media/amcor.64caa902.png";